<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@signUp">Sign Up</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="signupForm">
      <!-- @if (showEmailError) {
      <div class="error invalid-cridentials d-flex justify-content-center align-items-center">
        <mat-icon class="mr-8" i18n-aria-label aria-label="Error">error</mat-icon>
        <span i18n="@@usedEmail">This email is used!</span>
      </div>
    } -->

    <mat-horizontal-stepper linear #stepper>

      <mat-step [stepControl]="signupForm">
        <div class="form-group">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@accountTypeLabel">Account type</mat-label>
            <mat-select data-testid="signup_account_type" #accountType (selectionChange)="accountTypeChange($event.value)" id="account_type"
              name="account_type"  formControlName="account_type" i18n-placeholder="@@accountTypePlaceholder" placeholder="Account type" matNativeControl required>
              <mat-option [disabled]="type === 'manufacturer' ? true : false" i18n="@@distrebutor" value="distributor">Distributor</mat-option>
              <mat-option [disabled]="type === 'distributor' ? true : false" i18n="@@manufacturer" value="manufacturer">Manufacturer</mat-option>
            </mat-select>
            <mat-error>
              @if (!signupForm.get('account_type').valid && signupForm.get('account_type').touched) {
                @if (signupForm.get('account_type').errors && signupForm.get('account_type').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
            </mat-error>
          </mat-form-field>
        </div>
        @if (accountType.value === 'manufacturer') {
          <div class="form-group">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label i18n="@@manufacturerNameLabel">Manufacture name</mat-label>
              <input data-testid="signup_manufacture_name" matInput id="manufacture_name" i18n-placeholder="@@manufacturerNamePlaceholder" placeholder="Manufacture name" name="manufacture_name" formControlName="manufacture_name" required />
              <mat-error>
                @if (!signupForm.get('manufacture_name').valid && signupForm.get('manufacture_name').touched) {
                  @if (signupForm.get('manufacture_name').errors && signupForm.get('manufacture_name').errors['required'] || signupForm.get('manufacture_name').hasError('whitespace')) {
                    <span i18n="@@inValidRequiredField">This field is required</span>
                  }
                }
              </mat-error>
            </mat-form-field>
          </div>
        }
        @if (accountType.value === 'distributor') {
          <div class="form-group">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label i18n="@@companyNameLabel">Company name</mat-label>
              <input data-testid="signup_company_name" matInput id="company_name" i18n-placeholder="@@companyNamePlaceholder"  placeholder="Company name" name="company_name" formControlName="company_name" required />
              <mat-error>
                @if (!signupForm.get('company_name').valid && signupForm.get('company_name').touched) {
                  @if (signupForm.get('company_name').errors && signupForm.get('company_name').errors['required'] || signupForm.get('company_name').hasError('whitespace')) {
                    <span i18n="@@inValidRequiredField">This field is required</span>
                  }
                }
              </mat-error>
            </mat-form-field>
          </div>
        }
        <div class="form-group">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@emailLabel">Email</mat-label>
            <input data-testid="signup_email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder" name="email" formControlName="email" required />
            <mat-error>
              @if (!signupForm.get('email').valid && signupForm.get('email').touched) {
                @if (signupForm.get('email').errors && signupForm.get('email').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
              @if (signupForm.get('email').errors && !signupForm.get('email').errors['required'] && signupForm.get('email').errors['emailNotValid']) {
                <span i18n="@@inValidEmail">Please enter a valid email</span>
              }
              @if (signupForm.get('email')?.hasError('emailUsed')) {
                <span i18n="@@usedEmail">This email is used!</span>
              }
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@passwordLabel">Password</mat-label>
            <input data-testid="signup_password" i18n-placeholder="@@passwordPlaceholder" #password [type]="hide ? 'password' : 'text'" matInput id="password" placeholder="Password" name="password" formControlName="password" [required]="hide" autocomplete="new-password"/>
            <mat-icon class="cursor" matSuffix (click)="hide = !hide" i18n-aria-label aria-label="{{hide ? 'Hide content' : 'Show content'}}">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
            <mat-hint align="end" [class]="meterMessage" >
              {{meterMessage}}
            </mat-hint>
            <mat-error>
              @if (!signupForm.get('password').valid && signupForm.get('password').touched) {
                @if (signupForm.get('password').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
              @if (signupForm.get('password').errors && signupForm.get('password').errors['pattern']) {
                <span i18n="@@inValidPassword">Password should be at least 8 alphanumeric characters!</span>
              }
            </mat-error>
          </mat-form-field>
        </div>
        <div style="display: none">
          <password-strength-meter
            *ngIf="signupForm?.get('password')"
            [password]="signupForm.get('password').value"
            (strengthChange)="onStrengthChanged($event)">
          </password-strength-meter>
        </div>

        <div class="accept-terms-style mat-caption">
          <mat-checkbox data-testid="terms_privacy" (change)="privacyAndTerms($event)" color="accent">
            <span i18n="@@iAccept">I accept the </span>
            <a i18n="@@privacyPolicy" (click)="navigateTo('/privacy')">Privacy Policy</a>
            <span i18n="@@and"> and </span>
            <a i18n="@@termsAndConditions" (click)="navigateTo('/terms')">Terms & Conditions</a>
          </mat-checkbox>
        </div>
        @if (checkedPrivacyAndTerms === false) {
          <p i18n="@@acceptPrivacyAndTerms" class="error">Please accept privacy and terms and conditions to continue</p>
        }
        <div>
          @if (plan !== 'lite' && plan !== 'free' && checkedPrivacyAndTerms !== true) {
            <button i18n="@@signUp" data-testid="signup_button" class="w-100" mat-raised-button color="primary" (click)="checkedPrivacyAndTerms=false">Sign Up</button>
          }
          @if (plan !== 'lite' && plan !== 'free' && checkedPrivacyAndTerms === true) {
            <button i18n="@@signUp" data-testid="signup_button" class="w-100" mat-raised-button color="primary" matStepperNext>Sign Up</button>
          }
          @if (plan === 'lite' || plan === 'free') {
            <button i18n="@@signUp" data-testid="signup_button" class="w-100" mat-raised-button color="primary" (click)="signup()">Sign Up</button>
          }
        </div>
        <div class="check-pricing-style mat-caption text-center">
          <span i18n="@@checkToKnowMore">To know more check </span>
          <div class="mat-subtitle-1 d-inline">
            <a i18n="@@pricing" data-testid="pricing_link" class="cursor" (click)="navigateTo('/pricing')">Pricing</a>
          </div>
        </div>
      </mat-step>

      <mat-step  [stepControl]="billingForm" >
        <mat-card class="billing-card">
          <mat-card-content>
            <div class="mat-headline-4" i18n="@@billing">Billing</div>
            <form [formGroup]="billingForm" class="mt-30">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label i18n="@@annualFee">Annual fee</mat-label>
                <input formControlName="annualFee" matInput disabled id="annualFee" name="annualFee"/>
              </mat-form-field>
            </form>
            <div class="d-flex mt-30">
              <button data-testid="add_promotions_button" class="w-100 mr-16" mat-raised-button color="accent" i18n="@@buyWithCard" (click)="buyWithCard()">Buy with card</button>
              <div data-testid="paypal_button" class="w-100" id="paypal-checkout-btn"></div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</mat-dialog-content>